// extracted by mini-css-extract-plugin
export default {"automatic":"ConnectionLostModal-automatic-O5Z3a"};